import { BsCloudCheck } from 'react-icons/bs';

export function Saved() {
  return <BsCloudCheck color="var(--color-charcoal)" />;
}
